import defaultSettings from "@/settings";
import { Module, MutationTree, ActionTree } from "vuex";

const state: settingState = {
  showSettings: defaultSettings.showSettings,
  fixedHeader: defaultSettings.fixedHeader,
  sidebarLogo: defaultSettings.sidebarLogo,
  updateSettings: defaultSettings.updateSettings,
};

const mutations: MutationTree<settingState> = {
  CHANGE_SETTING(state, { key, value }: ChangeSettingPayload) {
    if (state.hasOwnProperty(key)) {
      state[key] = value;
    }
  },
};

const actions: ActionTree<settingState, any> = {
  changeSetting({ commit }, data: ChangeSettingPayload) {
    commit("CHANGE_SETTING", data);
  },
};

const settingsModule: Module<settingState, any> = {
  namespaced: true,
  state,
  mutations,
  actions,
};

export default settingsModule;
